import React, { useId } from "react";

export const LogoMark = ({ className = "h-8 w-8", light = false }) => {
  const gap = light ? "#071D49" : "#07111A";
  const uid = useId().replace(/:/g, '');
  return (
    <svg viewBox="0 0 120 120" fill="none" className={className} aria-hidden="true">
      <defs>
        <linearGradient id={`${uid}-n3b`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#C2ECFC" />
          <stop offset="1" stopColor="#5FB9DE" />
        </linearGradient>
        <linearGradient id={`${uid}-n3s`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#F1FBFF" />
          <stop offset="1" stopColor="#A6CDE3" />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${uid}-n3b)`}
        d="M14 12 H42 L84 64 V12 H106 V108 H78 L36 56 V108 H14 Z"
      />
      <path
        fill={`url(#${uid}-n3s)`}
        stroke={gap}
        strokeWidth="6"
        d="M78 12 H106 V108 H78 Z"
      />
      <path fill={gap} d="M60.9 35.4 L67.2 43.2 L61.2 87.2 L54.9 79.4 Z" />
    </svg>
  );
};

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark light={light} className="h-8 w-8" />
    <span className="leading-none">
      <span
        className={`font-display text-[19px] font-extrabold tracking-tight ${
          light ? "text-white" : "text-navy"
        }`}
      >
        N3LEDGE
      </span>
      <span
        className={`mt-1 block font-mono text-[8.5px] font-medium tracking-[0.34em] ${
          light ? "text-white/60" : "text-action"
        }`}
      >
        EUROPE
      </span>
    </span>
  </span>
);
